export { ViaplayVideo } from './ViaplayVideo';
